"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SPACE_DISCONNECT_TYPE = exports.SPACE_ACCEPT_REQUEST_TYPE = exports.SPACE_REQUEST_TYPE = exports.ADDITIONAL_META_TYPE = exports.IDENTITY_TYPE = exports.NOTIFICATION_TYPE = void 0;
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./sendNotifications"), exports);
var constants_1 = require("./constants");
Object.defineProperty(exports, "NOTIFICATION_TYPE", {
  enumerable: true,
  get: function () {
    return constants_1.NOTIFICATION_TYPE;
  }
});
Object.defineProperty(exports, "IDENTITY_TYPE", {
  enumerable: true,
  get: function () {
    return constants_1.IDENTITY_TYPE;
  }
});
Object.defineProperty(exports, "ADDITIONAL_META_TYPE", {
  enumerable: true,
  get: function () {
    return constants_1.ADDITIONAL_META_TYPE;
  }
});
Object.defineProperty(exports, "SPACE_REQUEST_TYPE", {
  enumerable: true,
  get: function () {
    return constants_1.SPACE_REQUEST_TYPE;
  }
});
Object.defineProperty(exports, "SPACE_ACCEPT_REQUEST_TYPE", {
  enumerable: true,
  get: function () {
    return constants_1.SPACE_ACCEPT_REQUEST_TYPE;
  }
});
Object.defineProperty(exports, "SPACE_DISCONNECT_TYPE", {
  enumerable: true,
  get: function () {
    return constants_1.SPACE_DISCONNECT_TYPE;
  }
});
//# sourceMappingURL=index.js.map